import { call, put, select, takeLatest } from 'redux-saga/effects'
import { PcrDocsService } from '../../../../services/pcrDocs.service'
import { getPcrIdSelector } from '../../../home/selectors'
import { throwPcrException } from '../../../pcr/store/pcr.actions'
import { IPcr } from '../../../pcr/store/pcr.types'
import { getServiceIdSelector } from '../../../user/selectors'
import { getCardiacSelector } from '../selectors'
import { saveCardiac } from '../store/cardiac.actions'
import { CardiacConstants } from '../store/cardiac.constants'
import { ICardiacState } from '../store/cardiac.types'
import { performWithMutexHOG } from '../../../../services/mutexUtility.service'

export function* setComments() {
  const cardiacState: ICardiacState = yield select(getCardiacSelector)
  const { comments } = cardiacState
  const serviceId: string = yield select(getServiceIdSelector)
  const pcrDocsService = new PcrDocsService(serviceId)
  const pcrID: string = yield select(getPcrIdSelector)
  if (pcrID) {
    try {
      const pcrDoc: IPcr = yield call([pcrDocsService, pcrDocsService.getPCR], pcrID)
      if (pcrDoc.patient?.cardiacStateList && pcrDoc.patient?.cardiacStateList.length) {
        const index = pcrDoc.patient?.cardiacStateList?.findIndex((cardiac) => cardiac.key === cardiacState.key)
        if (index !== -1) {
          if (pcrDoc.patient.cardiacStateList[index].comments !== comments) {
            yield put(saveCardiac())
          }
        }
      } else {
        yield put(saveCardiac())
      }
    } catch (e) {
      yield put(throwPcrException(`setComments() error: ${e}`))
    }
  } else {
    // todo: add to audit log
  }
}

export function* setCommentsSaga() {
  yield takeLatest([CardiacConstants.SET_COMMENTS], performWithMutexHOG, setComments)
}
